module.exports = {"411526001":"春申街道","411526002":"定城街道","411526003":"弋阳街道","411526004":"老城街道","411526101":"双柳树镇","411526102":"伞陂镇","411526103":"卜塔集镇","411526105":"仁和镇","411526106":"付店镇","411526107":"踅孜镇","411526108":"桃林铺镇","411526109":"黄寺岗镇","411526110":"江家集镇","411526201":"传流店乡","411526202":"魏岗乡","411526203":"张集乡","411526204":"来龙乡","411526205":"隆古乡","411526206":"谈店乡","411526207":"上油岗乡","411526209":"白店乡","411526400":"黄湖农场","411526560":"河南省潢川经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411526.json
// module id = 1671
// module chunks = 0